import { Box, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import { ProductCardList as ProductCardListUI } from '@wix/premium-purchase-platform/@ui';
import React from 'react';
import styles from './ProductCardsSkeleton.scss';

export interface ProductCardsSkeletonProps {
  numCards?: number;
  dataHook?: string;
}

export const ProductCardsSkeleton = ({
  numCards = 4,
  dataHook = 'product-cards-skeleton',
}: ProductCardsSkeletonProps) => {
  const skeletonClassName = styles.skeletonRectangle;

  return (
    <ProductCardListUI.Root
      gap={12}
      margin="0 auto"
      width="100%"
      dataHook={dataHook}
    >
      {Array.from({ length: numCards }).map((_, index) => (
        <ProductCardListUI.Card.Root
          key={index}
          width="100%"
          borderRadius="12px"
          height="483px"
        >
          <Box width="100%" height="100%" align="left" direction="vertical">
            <SkeletonGroup>
              <Box direction="vertical" marginLeft="24px" marginTop="74px">
                <SkeletonRectangle
                  className={skeletonClassName}
                  height="20px"
                  width="78px"
                />
                <SkeletonRectangle
                  className={skeletonClassName}
                  height="12px"
                  width="120px"
                  marginTop="11px"
                />
                <SkeletonRectangle
                  className={skeletonClassName}
                  height="33px"
                  width="78px"
                  marginTop="15px"
                />
                <SkeletonRectangle
                  className={skeletonClassName}
                  height="36px"
                  width="100%"
                  marginTop="30px"
                />
                <SkeletonRectangle
                  className={skeletonClassName}
                  height="12px"
                  width="108px"
                  marginTop="26px"
                />
                <SkeletonRectangle
                  className={skeletonClassName}
                  height="12px"
                  width="186px"
                  marginTop="24px"
                />
                <SkeletonRectangle
                  className={skeletonClassName}
                  height="12px"
                  width="150px"
                  marginTop="24px"
                />
                <SkeletonRectangle
                  className={skeletonClassName}
                  height="12px"
                  width="120px"
                  marginTop="24px"
                />
                <SkeletonRectangle
                  className={skeletonClassName}
                  height="12px"
                  width="162px"
                  marginTop="24px"
                />
              </Box>
            </SkeletonGroup>
          </Box>
        </ProductCardListUI.Card.Root>
      ))}
    </ProductCardListUI.Root>
  );
};
